<template>
  <v-container class="sidebar--navigation">
 <v-row justify-center>
    <v-col cols="12">
      <v-card elevation="2">
        <v-row no-gutters>
          <v-col cols="4"
              :style="{ paddingTop: '100px' }"
          >
            <v-img
              v-if="getProductImage(product.attributes) != ''"
              :src="getProductImage(product.attributes)"
              height="200"
              contain
            ></v-img>
             <v-img
                v-else
                :src="require('@/assets/images/logos/shopify.png')"
                height="200"
                contain
            ></v-img>
          </v-col>
          <v-col cols="8">
            <v-card-title class="text-h5 grey lighten-2">
              <v-img
                max-height="35"
                max-width="35"
                :src="require('@/assets/images/logos/shopify.png')"
              ></v-img>
              &nbsp;Product Details
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="product.id !== undefined">
              <v-row>
                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Title: {{ product.title }}</p>
                  <p class="font-weight-bold">SKU: {{ product.sku }}</p>
                  <p class="font-weight-bold d-flex align-center">
                    Vendor: <v-icon info class="mr-1">{{icons.mdiStore}}</v-icon>
                    {{ product.vendor }}
                  </p>
                    <p class="font-weight-bold" v-if="product.variations.length == 0">
                    Inventory Tracking:
                    <v-icon small :style="{ color: product.inventory_tracking === '1' ? '#077017' : 'red' }">
                      {{ product.inventory_tracking === '1' ? icons.mdiCheckCircle : icons.mdiCancel }}
                    </v-icon>
                      {{ product.inventory_tracking === '1' ? 'Tracked' : 'Not Tracked' }}
                  </p>
                  <p v-html="getWeightAndWeightUnit(product.attributes)"></p>
                  <v-btn small outlined color="primary" @click="openInventorySettingsDialog">
                    <v-icon small left>{{ icons.mdiRefresh }}</v-icon>
                    Check Continue Selling (live from Shopify)
                  </v-btn>
                </v-col>

                <v-col cols="12" md="6">
                  <p class="font-weight-bold">Price: {{this.shop.currency }} {{ product.price }}</p>
                  <p class="font-weight-bold">Stock Quantity: {{ product.stock_quantity }}</p>
                  <p class="font-weight-bold">Published At: {{ product.published_at }}</p>
                  <p class="font-weight-bold">Description: {{ product.description }}</p>

                  <strong class="font-weight-bold"><u>Options:</u></strong>
                    <div v-for="option in getProductOptions(product.attributes)" :key="option.name">
                        <strong>{{ option.name }}:</strong>
                        <span v-for="(value, index) in option.values" :key="value">
                          {{ value }}<span v-if="index < option.values.length - 1">, </span>
                        </span>
                      </div>
                </v-col>

                <v-col cols="12" md="6">
                  <h4>Metafields:</h4>
                    <ul>
                      <li v-for="(value, key) in parseMetafields(product.metafields)" :key="key">
                        <span v-if="typeof value === 'object' && Object.keys(value).every(k => !isNaN(k))">
                          {{ formatMetafield(value) }}
                        </span>
                        <span v-else>
                          <strong>{{ key }}:</strong> {{ formatMetafield(value) }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
              </v-row>

              <!-- Add more product details as needed -->
            </v-card-text>
            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>Etsy Shop not Connected!!</h3>
              </div>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
    </br>


    <v-card class="p-1">
      <v-card-title>
         Product Variations
      </v-card-title>

      <v-data-table :headers="headers" :items="product.variations" disable-pagination hide-default-footer>
        <template v-slot:body="{ items }">
          <tbody v-if="!loading_data">
            <tr v-if="!items.length">
              <td colspan="6" class="text-center" style="padding: 20px 0px">
                <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
                <p style="font-size: 25px">No Data Found!!</p>
              </td>
            </tr>
            <tr v-else v-for="item in items" :key="item.id">
              <td>
               #{{ item.variant_id }}
              </td>
              <td style="padding: 4px"><img width="50px" :src="getProductImage(product.attributes, item.variant_id)" alt="" /></td>
              <td style="max-width: 300px; font-size: 12px">
                <strong v-html="getVariantTitle(item)"></strong>
              </td>
              <td>{{ item.sku }}</td>
              <td>
                <v-icon small :style="{ color: item.inventory_tracking === '1' ? '#077017' : 'red' }">
                      {{ item.inventory_tracking === '1' ? icons.mdiCheckCircle : icons.mdiCancel }}
                    </v-icon>
                      {{ item.inventory_tracking === '1' ? 'Tracked' : 'Not Tracked' }}
              </td>
              <td>
                  {{ item.stock_quantity}}
              </td>
              <td>
                {{shop.currency }} {{item.price}}
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center" style="padding: 80px 0px">
                <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    </br>

    <v-card class="p-1">
      <v-card-title>
        Product Media
      </v-card-title>

      <v-tabs v-model="media_tab">
        <v-tab>Images</v-tab>
        <v-tab>Videos</v-tab>
      </v-tabs>

      <v-tabs-items v-model="media_tab">
        <!-- Images Tab -->
        <v-tab-item>
            <v-card-text style="padding-top: 24px;">
            <v-row
              v-if="getProductImages().length > 0"
              no-gutters
            >
              <v-col
                v-for="(imageUrl, index) in getProductImages()"
                :key="index"
                cols="12"
                md="3"
                sm="4"
              >
                <v-img
                  :src="imageUrl"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  contain
                  max-width="100"
                  max-height="100"
                ></v-img>
              </v-col>
            </v-row>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Images Found</p>
            </div>
          </v-card-text>
        </v-tab-item>

        <!-- Videos Tab -->
        <v-tab-item>
          <v-card-text style="padding-top: 24px;">
            <div v-if="videos.length > 0">
              <v-card
                v-for="(video, index) in videos"
                :key="index"
                class="mb-3"
                outlined
              >
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-avatar size="80" color="grey lighten-2">
                        <v-icon size="40" color="primary">{{ icons.mdiPlay }}</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <p class="mb-1">
                        <strong>Video {{ index + 1 }}</strong>
                      </p>
                      <p v-if="video.sources && video.sources[0]" class="text-caption grey--text mb-0">
                        Format: {{ video.sources[0].format }} |
                        Resolution: {{ video.sources[0].width }}x{{ video.sources[0].height }}
                      </p>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        color="primary"
                        @click="openVideoDialog(video)"
                      >
                        <v-icon left>{{ icons.mdiPlay }}</v-icon>
                        Play Video
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <div v-else class="text-center" style="padding: 40px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 20px">No Videos Found</p>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    </br>

    <!-- Product Inventory (Locations) -->
    <v-card class="p-1">
      <v-card-title>
        Product Inventory (Locations)
      </v-card-title>

      <!-- Loading -->
      <div v-if="inventory_loading" class="text-center" style="padding: 40px 0">
        <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
      </div>

      <!-- Error -->
      <v-card-text v-else-if="inventory_error">
        <v-alert type="error" dense>{{ inventory_error }}</v-alert>
      </v-card-text>

      <!-- Data -->
      <v-card-text v-else-if="inventory_data">

        <!-- Verdict banner -->
        <v-alert
          v-if="inventoryVerdictType"
          :type="inventoryVerdictType"
          dense
          text
          class="mb-4"
        >
          {{ inventory_data.verdict.message }}
        </v-alert>
        <v-sheet v-else outlined rounded class="mb-4 pa-3" color="grey lighten-4">
          <span class="grey--text text--darken-1">{{ inventory_data.verdict.message }}</span>
        </v-sheet>

        <!-- Summary metrics -->
        <v-row class="mb-4" dense>
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h6" :class="inventoryDbStockColor">{{ inventory_data.totals.db_stock_quantity }}</div>
              <div class="caption grey--text">Stored DB stock (pushed to Etsy)</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h6" :class="inventory_data.enabled_gate.all_enabled ? '' : 'success--text'">{{ inventory_data.totals.enabled_locations_sum }}</div>
              <div class="caption grey--text">{{ inventory_data.enabled_gate.all_enabled ? 'Stock sum (all locations)' : 'Enabled-location sum' }}</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined class="pa-3 text-center">
              <div class="text-h6">{{ inventory_data.totals.all_locations_sum }}</div>
              <div class="caption grey--text">All-location sum</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Enabled-locations gate -->
        <v-alert v-if="inventory_data.enabled_gate.all_enabled" type="success" text dense class="mb-4">
          <strong>All locations enabled</strong> — <code>enabled_locations</code> is null/empty, every location syncs.
        </v-alert>
        <v-alert v-else type="warning" text dense class="mb-4">
          <div class="mb-1"><strong>Subset enabled</strong> — only these location(s) sync to Etsy:</div>
          <div class="d-flex flex-wrap" style="gap: 6px">
            <v-chip
              v-for="loc in inventory_data.enabled_gate.locations"
              :key="loc.location_id"
              x-small
              class="inv-chip-location"
            >
              {{ loc.name || '(unnamed)' }} #{{ loc.location_id }}<span v-if="loc.is_default"> · default</span>
            </v-chip>
            <span v-if="!inventory_data.enabled_gate.locations.length" class="caption">none resolved</span>
          </div>
        </v-alert>

        <!-- Variant cards -->
        <v-card
          v-for="(variant, idx) in inventory_data.variants"
          :key="variant.variant_id"
          outlined
          class="mb-3"
        >
          <!-- Variant header -->
          <div class="d-flex align-center flex-wrap pa-3" style="border-bottom: 1px solid rgba(0,0,0,0.08)">
            <span class="font-weight-bold mr-2">{{ variant.title || variant.sku || ('variant ' + variant.variant_id) }}</span>
            <span v-if="variant.sku" class="caption grey--text mr-2">{{ variant.sku }}</span>
            <span class="caption grey--text mr-2">#{{ variant.variant_id }}</span>
            <v-spacer></v-spacer>
            <v-chip x-small :class="variantBadgeClass(variant)">{{ variantBadgeLabel(variant) }}</v-chip>
          </div>

          <!-- Stock pills row -->
          <div class="d-flex flex-wrap pa-3" style="gap: 6px; border-bottom: 1px solid rgba(0,0,0,0.08); background: #fafafa">
            <v-chip x-small class="inv-chip-db">DB stock {{ variant.db_stock_quantity }}</v-chip>
            <v-chip x-small :class="inventory_data.enabled_gate.all_enabled ? 'inv-chip-stock' : 'inv-chip-enabled'">
              {{ inventory_data.enabled_gate.all_enabled ? 'stock' : 'enabled' }} sum {{ variant.enabled_locations_sum }}
            </v-chip>
            <v-chip
              v-if="!inventory_data.enabled_gate.all_enabled && variant.all_locations_sum !== variant.enabled_locations_sum"
              x-small
              class="inv-chip-stock"
            >
              all-locations sum {{ variant.all_locations_sum }}
            </v-chip>
          </div>

          <!-- No inventory rows message -->
          <div v-if="!variant.has_inventory_rows" class="pa-4 caption grey--text">
            No per-location inventory cached for this variant (shopify_variation_inventories has no rows).
          </div>

          <!-- Enabled location rows -->
          <template v-else>
            <div v-if="enabledLevels(variant).length === 0" class="pa-3 caption amber--text text--darken-3" style="background: #fffde7">
              No inventory cached at the enabled location(s)
              <span v-if="excludedLevels(variant).length">
                — but {{ excludedLevels(variant).reduce((s, l) => s + (l.available_quantity || 0), 0) }} unit(s) sit at excluded location(s) below.
              </span>
            </div>
            <div v-else class="overflow-x-auto">
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">Location</th>
                    <th class="text-right">Available</th>
                    <th class="text-right">Committed</th>
                    <th class="text-left">Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="level in enabledLevels(variant)" :key="level.location_id">
                    <td>
                      <div class="font-weight-medium">
                        {{ level.location_name || '(unnamed)' }}
                        <v-chip v-if="level.is_default" x-small class="inv-chip-default ml-1">default</v-chip>
                        <v-chip v-if="level.active === false" x-small class="inv-chip-inactive ml-1">inactive</v-chip>
                      </div>
                      <div class="caption grey--text">#{{ level.location_id }}</div>
                    </td>
                    <td class="text-right font-weight-bold">{{ level.available_quantity }}</td>
                    <td class="text-right grey--text">{{ level.committed_quantity }}</td>
                    <td class="caption grey--text">{{ level.inventory_updated_at || '—' }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>

            <!-- Excluded locations toggle -->
            <div v-if="excludedLevels(variant).length" style="border-top: 1px solid rgba(0,0,0,0.08)">
              <v-btn
                text
                small
                class="ml-1 my-1 grey--text text--darken-1"
                @click="toggleExcluded(idx)"
              >
                <v-icon small class="mr-1">{{ expanded_excluded[idx] ? icons.mdiChevronDown : icons.mdiChevronRight }}</v-icon>
                {{ excludedLevels(variant).length }} excluded location{{ excludedLevels(variant).length === 1 ? '' : 's' }}
                · {{ excludedLevels(variant).reduce((s, l) => s + (l.available_quantity || 0), 0) }} unit(s) not synced
                <span class="ml-2 caption">{{ expanded_excluded[idx] ? 'hide' : 'show' }}</span>
              </v-btn>
              <div v-if="expanded_excluded[idx]" class="overflow-x-auto">
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th class="text-left grey--text">Location</th>
                      <th class="text-right grey--text">Available</th>
                      <th class="text-right grey--text">Committed</th>
                      <th class="text-left grey--text">Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="level in excludedLevels(variant)" :key="level.location_id" class="grey--text">
                      <td>
                        <div>
                          {{ level.location_name || '(unnamed)' }}
                          <v-chip v-if="level.is_default" x-small class="inv-chip-default ml-1">default</v-chip>
                          <v-chip v-if="level.active === false" x-small class="inv-chip-inactive ml-1">inactive</v-chip>
                        </div>
                        <div class="caption">#{{ level.location_id }}</div>
                      </td>
                      <td class="text-right">{{ level.available_quantity }}</td>
                      <td class="text-right">{{ level.committed_quantity }}</td>
                      <td class="caption">{{ level.inventory_updated_at || '—' }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </div>
          </template>
        </v-card>

      </v-card-text>

      <!-- Empty/not loaded state -->
      <v-card-text v-else>
        <div class="text-center grey--text py-8">No inventory data available.</div>
      </v-card-text>
    </v-card>

    <!-- Live Inventory Settings Dialog (fetched from Shopify on demand) -->
    <v-dialog v-model="inventory_settings_dialog" max-width="1000" scrollable>
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          <span>Inventory Tracking &amp; Continue Selling (live from Shopify)</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="inventory_settings_dialog = false">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <div v-if="inventory_settings_loading" class="text-center" style="padding: 40px 0">
            <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
          </div>

          <v-alert v-else-if="inventory_settings_error" type="error" dense>{{ inventory_settings_error }}</v-alert>

          <div v-else-if="inventory_settings">
            <div class="mb-3">
              <div class="font-weight-bold">{{ inventory_settings.product.title }}</div>
              <div class="caption grey--text">
                Shopify #{{ inventory_settings.product.shopify_id }} · {{ inventory_settings.product.status }}
                · {{ inventory_settings.variants.length }} variant(s) · fetched {{ inventory_settings.fetched_at }}
              </div>
            </div>

            <v-alert
              v-if="inventory_settings.product.variants_count !== null && inventory_settings.product.variants_count > inventory_settings.variants.length"
              type="warning"
              dense
              text
            >
              Showing {{ inventory_settings.variants.length }} of {{ inventory_settings.product.variants_count }} variants.
            </v-alert>

            <div class="overflow-x-auto">
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">Variant</th>
                    <th class="text-left">SKU</th>
                    <th class="text-left">Inventory Tracked</th>
                    <th class="text-left">Continue Selling When Out of Stock</th>
                    <th class="text-right">Shopify Qty</th>
                    <th class="text-left">Stored In App</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="variant in inventory_settings.variants" :key="variant.variant_id">
                    <td>
                      <div class="font-weight-medium">{{ variant.title }}</div>
                      <div class="caption grey--text">#{{ variant.variant_id }}</div>
                    </td>
                    <td>{{ variant.sku || '—' }}</td>
                    <td>
                      <v-icon small :style="{ color: variant.tracked ? '#077017' : 'red' }">
                        {{ variant.tracked ? icons.mdiCheckCircle : icons.mdiCancel }}
                      </v-icon>
                      {{ variant.tracked ? 'Tracked' : 'Not Tracked' }}
                    </td>
                    <td>
                      <template v-if="variant.tracked">
                        <v-chip x-small :class="variant.inventory_policy === 'CONTINUE' ? 'inv-chip-badge-warn' : 'inv-chip-badge-match'">
                          {{ variant.inventory_policy }}
                        </v-chip>
                      </template>
                      <span v-else class="caption grey--text">N/A (not tracked)</span>
                    </td>
                    <td class="text-right">{{ variant.inventory_quantity }}</td>
                    <td class="caption">
                      <span v-if="variant.stored_inventory_tracking === null" class="grey--text">not in app</span>
                      <span v-else>inventory_tracking = {{ variant.stored_inventory_tracking }}</span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>

            <div class="caption grey--text mt-3">
              CONTINUE = customers can keep buying after stock reaches 0. DENY = sales stop at 0.
              The policy only applies when inventory is tracked.
              "Stored In App" is our inventory_tracking flag, which is 1 only when the variant is tracked <strong>and</strong> DENY.
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="primary" :disabled="inventory_settings_loading" @click="fetchInventorySettings">
            <v-icon small left>{{ icons.mdiRefresh }}</v-icon>
            Refresh
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="inventory_settings_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Video Popup Dialog -->
    <v-dialog v-model="video_dialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <span>Video Player</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeVideoDialog">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-if="selected_video && getVideoUrl(selected_video)">
            <video
              :src="getVideoUrl(selected_video)"
              controls
              style="width: 100%; max-width: 100%;"
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else class="text-center pa-4">
            <p>Video URL not available</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeVideoDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import store from '@/store'
import { mdiChevronDown, mdiChevronRight, mdiClose, mdiCheckCircle, mdiStore, mdiCancel, mdiPlay, mdiRefresh } from '@mdi/js'
import { get } from 'lodash';
export default {
  data() {
    return {
      productId: null,
      product: {},
      loading_data: false,
      shop: null,
      videos: [],
      video_dialog: false,
      selected_video: null,
      media_tab: 0,
      inventory_data: null,
      inventory_loading: false,
      inventory_error: null,
      expanded_excluded: {},
      inventory_settings_dialog: false,
      inventory_settings: null,
      inventory_settings_loading: false,
      inventory_settings_error: null,
      headers: [
        {
          text: 'Variant ID',
          value: 'variant_id',
        },
        {
          text: 'Image',
        },
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'SKU',
          value: 'sku',
        },
        {
          text: 'Inventory Tracking',
          value: 'inventory_tracking',
        },
        {
          text: 'Inventory',
        },

        {
          text: 'Price',
        },
      ],
      icons: {
        mdiChevronDown,
        mdiChevronRight,
        mdiClose,
        mdiCheckCircle,
        mdiCancel,
        mdiStore,
        mdiPlay,
        mdiRefresh
      },
      variation_headers: [
        {
          text: 'Attributes',
        },
        { text: 'SKU' },
        { text: 'Price' },
        { text: 'Stock' },
      ],

    }
  },

  async mounted() {
    this.productId = this.$route.params.product_id;
    this.shop = store.getters.loggedInShop
    this.fetchShopifyProduct()
    this.fetchInventory()
  },

  computed: {
    inventoryVerdictType() {
      const map = { ok: 'success', bug: 'error', warn: 'warning', info: 'info' }
      return map[this.inventory_data?.verdict?.level] || null
    },

    inventoryDbStockColor() {
      const level = this.inventory_data?.verdict?.level
      if (level === 'bug') return 'error--text'
      if (level === 'ok') return 'success--text'
      return ''
    },
  },

  methods: {

    async fetchInventory() {
      try {
        this.inventory_loading = true
        this.inventory_error = null
        const response = await axios.get(`admin/shops/${this.shop.id}/shopify-product/${this.productId}/inventory`)
        if (response.data.success) {
          this.inventory_data = response.data
        } else {
          this.inventory_error = response.data.message || 'Failed to load inventory data.'
        }
      } catch (e) {
        this.inventory_error = e.response?.data?.message || e.message || 'Failed to load inventory data.'
      } finally {
        this.inventory_loading = false
      }
    },

    openInventorySettingsDialog() {
      this.inventory_settings_dialog = true

      // Only hit Shopify the first time; the Refresh button re-fetches on demand.
      if (!this.inventory_settings && !this.inventory_settings_loading) {
        this.fetchInventorySettings()
      }
    },

    async fetchInventorySettings() {
      try {
        this.inventory_settings_loading = true
        this.inventory_settings_error = null
        const response = await axios.get(`admin/shops/${this.shop.id}/shopify-product/${this.productId}/inventory-settings`)
        if (response.data.success) {
          this.inventory_settings = response.data
        } else {
          this.inventory_settings_error = response.data.message || 'Failed to fetch inventory settings from Shopify.'
        }
      } catch (e) {
        this.inventory_settings_error = e.response?.data?.message || e.message || 'Failed to fetch inventory settings from Shopify.'
      } finally {
        this.inventory_settings_loading = false
      }
    },

    enabledLevels(variant) {
      if (!variant.levels) return []
      if (this.inventory_data?.enabled_gate?.all_enabled) return variant.levels
      return variant.levels.filter(l => l.enabled)
    },

    excludedLevels(variant) {
      if (!variant.levels) return []
      if (this.inventory_data?.enabled_gate?.all_enabled) return []
      return variant.levels.filter(l => !l.enabled)
    },

    toggleExcluded(idx) {
      this.$set(this.expanded_excluded, idx, !this.expanded_excluded[idx])
    },

    variantBadgeClass(variant) {
      if (!variant.has_inventory_rows) return 'inv-chip-badge-none'
      if (this.inventory_data?.enabled_gate?.all_enabled) return 'inv-chip-badge-all'
      if (variant.matches_enabled) return 'inv-chip-badge-match'
      if (variant.matches_all) return 'inv-chip-badge-all-loc'
      return 'inv-chip-badge-warn'
    },

    variantBadgeLabel(variant) {
      if (!variant.has_inventory_rows) return 'no cached inventory'
      if (this.inventory_data?.enabled_gate?.all_enabled) return 'all locations enabled'
      if (variant.matches_enabled) return '✓ matches enabled sum'
      if (variant.matches_all) return '✗ matches ALL-locations sum'
      return '⚠ no match'
    },

     async fetchShopifyProduct() {
      try {
        this.loading_data = true
        let response = await axios.get(`admin/shops/${this.shop.id}/shopify-product/${this.productId}`, {
        })
        if (response.data.success) {
          this.product = response.data.product
          this.videos = response.data.videos || []
          // this.is_first = false
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading_data = false
      }
    },

    getProductImage(product_attributes, variant_id = null) {
      // Validate input before parsing
      if (!product_attributes || product_attributes === 'undefined' || product_attributes === 'null') {
        return '';
      }

      try {
        const parsedAttributes = JSON.parse(product_attributes);
        let img_url = '';

        if (variant_id && Array.isArray(parsedAttributes.images)) {
          // Find first image that includes this variant_id
          const imageForVariant = parsedAttributes.images.find(img =>
              Array.isArray(img.variant_ids) && img.variant_ids.includes(String(variant_id))
          );
          if (imageForVariant) {
            img_url = imageForVariant.src;
          }
        }

        // Fallback: first image
        if (!img_url && Array.isArray(parsedAttributes.images) && parsedAttributes.images[0]) {
          img_url = parsedAttributes.images[0].src;
        }

        // Fallback: single image_url property
        if (!img_url) {
          img_url = parsedAttributes?.image_url || '';
        }

        return img_url;
      } catch (e) {
        console.error('Error parsing product attributes:', e);
        return '';
      }
    },

    getWeightAndWeightUnit(attributes){
      let prodAttr = JSON.parse(attributes);
      if(prodAttr.weight && prodAttr.weight_unit){
        return "<strong>Weight: </strong>" + prodAttr.weight + " " + prodAttr.weight_unit;
      }
      return '<strong>Weight: </strong>Not Set';
    },

     parseAttributes(attributes) {
      try {
        return JSON.parse(attributes);
      } catch (error) {
        console.error('Error parsing attributes:', error);
        return {};
      }
    },

    capitalizeFirstLetters(str) {
      return str
        .split(', ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(', ');
    },

    parseMetafields(metafields) {
      if (!metafields) return {};

      let parsed = {};
      try {
        parsed = JSON.parse(metafields);
      } catch (e) {
        console.error('Error parsing metafields:', e);
        return {};
      }

      // If parsed is an array, convert to object with numeric keys
      if (Array.isArray(parsed)) {
        const obj = {};
        parsed.forEach((v, i) => (obj[i] = v));
        parsed = obj;
      }

    return parsed;
  },

    formatMetafield(value) {
      if (Array.isArray(value)) {
        return value.map(v => this.formatMetafield(v)).join(', ');
      }

      if (typeof value === 'object' && value !== null) {
        // Special case: object has 'value' and 'unit' → show nicely
        if ('value' in value && 'unit' in value) {
          return `${value.value} ${value.unit.toLowerCase()}`;
        }

        // Only numeric keys starting from 0 → show values only
        const keys = Object.keys(value);
        const isArrayLike = keys.every(k => !isNaN(k));
        if (isArrayLike) {
          return keys.map(k => this.formatMetafield(value[k])).join(', ');
        }

        // Otherwise show key: value recursively
        return Object.entries(value)
          .map(([k, v]) => `${k}: ${this.formatMetafield(v)}`)
          .join(', ');
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();

        // If string is JSON array/object
        if ((trimmed.startsWith('[') && trimmed.endsWith(']')) ||
            (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
          try {
            const parsed = JSON.parse(trimmed.replace(/'/g, '"'));
            return this.formatMetafield(parsed); // recursive
          } catch (e) {
            return value;
          }
        }

        return value;
      }

      return value ?? '';
    },

    getVariantTitle(item)
    {
      try {
        const variations = JSON.parse(item.attributes).variations;
        return Object.entries(variations)
          .map(([key, value]) => `${key}: ${value}`)
          .join('<br>');
      } catch (e) {
        return JSON.parse(item.attributes).title;
      }
    },

    getProductOptions(attributes) {
      try {
        const parsed = JSON.parse(attributes);
        if (!parsed.options || !Array.isArray(parsed.options)) return [];

        return parsed.options.map(option => ({
          name: option.name,
          values: option.values || []
        }));
      } catch (e) {
        console.error('Error parsing options:', e);
        return [];
      }
    },

    getProductImages() {
      try {
        if (!this.product.attributes) return [];
        const attributes = JSON.parse(this.product.attributes);
        if (attributes.images && Array.isArray(attributes.images)) {
          return attributes.images.map(img => img.src).filter(src => src);
        }
        return [];
      } catch (e) {
        console.error('Error parsing product images:', e);
        return [];
      }
    },

    getVideoUrl(videoData) {
      if (!videoData) return '';

      // Try sources[0].url first
      if (videoData.sources && Array.isArray(videoData.sources) && videoData.sources.length > 0) {
        return videoData.sources[0].url || '';
      }

      // Fallback to originalSource.url
      if (videoData.originalSource && videoData.originalSource.url) {
        return videoData.originalSource.url;
      }

      return '';
    },

    openVideoDialog(videoData) {
      this.selected_video = videoData;
      this.video_dialog = true;
    },

    closeVideoDialog() {
      this.video_dialog = false;
      this.selected_video = null;
    }
  }
}
</script>

<style scoped>
/* Vuetify v-chip color prop does not support material modifiers (e.g. "blue lighten-4"). */
.inv-chip-db {
  background: #e0f2fe !important;
  color: #0369a1 !important;
}

.inv-chip-enabled {
  background: #ecfdf5 !important;
  color: #047857 !important;
}

.inv-chip-stock {
  background: #f1f5f9 !important;
  color: #64748b !important;
}

.inv-chip-location {
  background: #fef3c7 !important;
  color: #b45309 !important;
}

.inv-chip-default {
  background: #eef2ff !important;
  color: #4338ca !important;
}

.inv-chip-inactive {
  background: #f1f5f9 !important;
  color: #94a3b8 !important;
}

.inv-chip-badge-none {
  background: #e2e8f0 !important;
  color: #475569 !important;
}

.inv-chip-badge-all {
  background: #e0e7ff !important;
  color: #4338ca !important;
}

.inv-chip-badge-match {
  background: #d1fae5 !important;
  color: #047857 !important;
}

.inv-chip-badge-all-loc {
  background: #ffe4e6 !important;
  color: #be123c !important;
}

.inv-chip-badge-warn {
  background: #fef3c7 !important;
  color: #b45309 !important;
}
</style>
